import { render, staticRenderFns } from "./Parameteritem.vue?vue&type=template&id=3211c004&"
import script from "./Parameteritem.vue?vue&type=script&lang=js&"
export * from "./Parameteritem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports